import React from 'react';
import Select from 'react-select';

const customStyles = {
  option: (styles, props) => ({
    ...styles,
  }),
  multiValueLabel: (styles, props) => ({
    ...styles,
    backgroundColor: `${props.data.color}70`,
  }),
  multiValueRemove: (styles, props) => ({
    ...styles,
    backgroundColor: `${props.data.color}70`,
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: 'transparent',
    borderRadius: 0,
    borderTop: 0,
    borderLeft: 0,
    borderRight: 0,
    borderBottom: '1px solid #E0E0E0',
  }),
  valueContainer: (styles, props) => ({
    ...styles,
    padding: '2px 8px 2px 0',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  indicatorSeparator: () => ({ display: 'none' }),
};

export default (props) => <Select styles={customStyles} {...props} />;



// WEBPACK FOOTER //
// ./components/atoms/MultiselectWithSearch.js